<template>
  <a-modal
    :footer="null"
    :visible="visible"
    width="80%"
    centered
    :keyboard="false"
    :maskClosable="false"
    @cancel="handleCancel"
    :getContainer="getContainer"
    destroyOnClose
  >
    <div slot="title">文件预览</div>
    <FileShow
      ref="fileShow"
      :fileId="fileId"
      :type="type"
      :url="url"
      :style="{ height: '60vh' }"
    ></FileShow>
  </a-modal>
</template>

<script>
import FileShow from "@/components/FilesShow/index";
export default {
  components: { FileShow },
  data() {
    return {
      visible: false,
      fileId: "",
      type: "",
      url: "",
    };
  },
  methods: {
    init(record) {
      this.fileId = record.id;
      this.type = record.type;
      // if (record.belong == 2) {
      //   this.url = record.url.replace(/\//g, "/")
      //   console.log(this.url)
      // } else {
      //   this.url = record.url;
      // }
      this.url = record.url;
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
      this.$refs.fileShow.DestroyAll()
    },
    getContainer() {
      return document.getElementById("bodyContnet");
    },
  },
};
</script>

<style>
</style>